import React, { useCallback } from "react";
import classnames from "classnames";
import MediaQuery from "components/MediaQuery";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { QUEUE_TYPE_OPTIONS } from "./match-history-filters";
import DefaultSelect from "components/DefaultSelect";
import Summoner from "components/FilterManager/Filters/Summoner";
import Champion from "components/FilterManager/Filters/Champion";
import MultiFilter from "components/FilterManager/Filters/MultiFilter";
import { ReactComponent as TriangleArrowDown } from "svg/triangle-arrow-down.svg";

const MatchFilters = (props) => {
  const { getChampionName } = getRiotAssetsContext();
  const { filters, setFilters, onFiltersChanged } = props;

  const onFilterChange = useCallback(
    (type, option) => {
      onFiltersChanged();
      setFilters({ ...filters, [type]: option.value });
    },
    [filters],
  );

  const getLabel = (options, value) => {
    const foundOption = options.find((option) => option.value === value);
    return (foundOption && foundOption.label) || "";
  };

  const Filters = ({ isMobile }) => (
    <React.Fragment>
      <DefaultSelect
        title={"Change Queue Type"}
        group={"queuetype"}
        customButton={
          <div className="filter-select_mobile">
            <span>{getLabel(QUEUE_TYPE_OPTIONS, filters.queueType)}</span>
            <TriangleArrowDown className="dropdown-indicator" />
          </div>
        }
        className={`transparent-button`}
        isMobile={isMobile}
        options={QUEUE_TYPE_OPTIONS}
        onChange={(selected) => {
          onFilterChange("queueType", selected);
        }}
        value={filters.queueType}
        width={110}
        fontSize={14}
        isSearchable={false}
      />
      {isMobile ? (
        <>
          <Summoner
            value={filters.duoName}
            filterKey="duoName"
            className={"transparent-button-summoner"}
            onFilterChange={onFilterChange}
            customButton={
              <div className="filter-select_mobile">
                <span>{filters.duoName ? filters.duoName : "All Summoners"}</span>
                <TriangleArrowDown className="dropdown-indicator" />
              </div>
            }
            isMobile={isMobile}
            fontSize={12}
          />
          <Champion
            value={filters.championId}
            filterKey="championId"
            onFilterChange={onFilterChange}
            customButton={
              <div className="filter-select_mobile">
                <span>{filters.championId ? getChampionName(filters.championId) : "All Champions"}</span>
                <TriangleArrowDown className="dropdown-indicator" />
              </div>
            }
            isMobile={isMobile}
            fontSize={14}
            defaultSearch={true}
          />
        </>
      ) : (
        <MultiFilter
          filters={(({ championId, duoName }) => ({ championId, duoName }))(filters)}
          onFilterChange={onFilterChange}
        />
      )}
    </React.Fragment>
  );

  return (
    <div className="match-block_filters">
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        {(mediaQueryClassNames) => (
          <div className={classnames(mediaQueryClassNames, "flex-center")}>
            <Filters />
          </div>
        )}
      </MediaQuery>
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
        {(mediaQueryClassNames) => (
          <div className={classnames(mediaQueryClassNames, "flex-center")}>
            <Filters isMobile />
          </div>
        )}
      </MediaQuery>
    </div>
  );
};

export default MatchFilters;
